import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import { getCustomerBreadcrumbs } from "./customerNavigation";
import "./CustomerBreadcrumbs.css";

/** "Overview › Rewards" trail on every inner customer page (also used by the Partner layout via `getBreadcrumbs`) (the top-bar back button handles going back). */
const CustomerBreadcrumbs = ({ getBreadcrumbs = getCustomerBreadcrumbs }) => {
  const { pathname } = useLocation();
  const crumbs = getBreadcrumbs(pathname);
  if (crumbs.length === 0) return null; // Overview itself

  return (
    <div className="cust-crumbs">
      <nav aria-label="Breadcrumb">
        <ol className="cust-crumbs__list">
          {crumbs.map((crumb, i) => {
            const isLast = i === crumbs.length - 1;
            return (
              <li key={`${crumb.label}-${i}`} className="cust-crumbs__item">
                {crumb.to && !isLast ? (
                  <Link to={crumb.to}>{crumb.label}</Link>
                ) : (
                  <span aria-current={isLast ? "page" : undefined}>{crumb.label}</span>
                )}
                {!isLast && <FiChevronRight size={12} aria-hidden="true" />}
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

export default CustomerBreadcrumbs;
